<form-table
  [formType]="formTypeEnum.PPSTB"
  [all]="showAllForms"
  [displayedColumns]="['sequenceNumber', 'systemAffected', 'status']"
  [filter]="formsFilter"
  (rowClick)="rowSelectedEvent($event)"
  (error)="alert.error($event)"
>
</form-table>
